if (!String.prototype.toCloudFrontURL) {
  // eslint-disable-next-line
  String.prototype.toCloudFrontURL = function () {
    return String(this).replace(/enterjobedu.s3.ap-northeast-2.amazonaws.com/gi, 'assets.enterjobedu.co.kr');
  };
}
